// extracted by mini-css-extract-plugin
export var checkbox = "_9n-0";
export var circle = "_9n-3";
export var horizontalContainer = "_9n-7";
export var sm = "_9n-5";
export var switch0 = "_9n-2";
export var switchDisabled = "_9n-8";
export var switchEnabled = "_9n-1";
export var textSwitchContainer = "_9n-9";
export var textSwitchOption = "_9n-a";
export var textSwitchOptionSelected = "_9n-b";
export var verticalContainer = "_9n-6";
export var xs = "_9n-4";